import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { GcpEncryptionKeys } from '../models/GcpEncryptionKeys';

/**
 * no description
 */
export class ListGcpEncryptionKeysApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Get all encryption keys
   * @param accountId ID of the restore account
   * @param region Region
   * @param projectId The project ID
   */
  public async listGcpEncryptionKeys(accountId: string, region: string, projectId: string, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'accountId' is not null or undefined
    if (accountId === null || accountId === undefined) {
      throw new RequiredError("ListGcpEncryptionKeysApi", "listGcpEncryptionKeys", "accountId");
    }


    // verify required parameter 'region' is not null or undefined
    if (region === null || region === undefined) {
      throw new RequiredError("ListGcpEncryptionKeysApi", "listGcpEncryptionKeys", "region");
    }


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("ListGcpEncryptionKeysApi", "listGcpEncryptionKeys", "projectId");
    }


    // Path Params
    const localVarPath = '/projects/{projectId}/restore-accounts/{accountId}/regions/{region}/gcp-encryption-keys'
      .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)))
      .replace('{' + 'region' + '}', encodeURIComponent(String(region)))
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.GET, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class ListGcpEncryptionKeysApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to listGcpEncryptionKeys
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async listGcpEncryptionKeysWithHttpInfo(response: ResponseContext): Promise<HttpInfo<GcpEncryptionKeys >> {
    if (isCodeInRange("200", response.httpStatusCode)) {
      const body: GcpEncryptionKeys = ObjectSerializer.deserialize(
        await response.body.json(),
        "GcpEncryptionKeys", ""
      ) as GcpEncryptionKeys;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: GcpEncryptionKeys = await response.body.json() as GcpEncryptionKeys;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
